export const locale = {
    lang: 'en',
    data: {
        CLINIC_MESSAGE_NOTIFICATION: {
            DATE_FORMAT: 'dd/MM/yyyy',
            EMPTY: 'You have no messages',
            EMPTY_PATIENT: 'Patient not defined',
            VIEW_ALL: 'View all',
            VIEW_UNREAD: 'View unread',
            MAKE_AS_READ: 'Mark as read',
            GO_TO_MESSAGE: 'Go to customer chat',
            GO_TO_CHAT: 'Go to chat',
            REMAKE_TYPE: {
                REMAKE: 'Repetition',
                REMAKE_INITIAL: 'R',
                ADJUSTMENT: 'Adjustment',
                ADJUSTMENT_INITIAL: 'A',
            },
        },
    },
};
